import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getCategoriaCNH, cadastrarCategoriaCNH, alterarCategoriaCNH, excluirCategoriaCNH } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var CategoriasCNHEditar = function () {
    var services = {
        getItem: getCategoriaCNH,
        cadastrarItem: cadastrarCategoriaCNH,
        alterarItem: alterarCategoriaCNH,
        excluirItem: excluirCategoriaCNH,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.CATEGORIAS_CNH, paginaPermissao: FUNCIONALIDADES.CATEGORIAS_CNH, rota: ROUTES.CATEGORIAS_CNH, services: services });
};
export default CategoriasCNHEditar;
